import checkIcon from "../../assets/pictures/icons/check-icon.svg";
import { IAvatarGender } from "../../utils";
import styles from "./AvatarOption.module.scss";
import { useTranslation } from "react-i18next";

interface Props {
    el: IAvatarGender;
    isSelected: boolean;
    imageStatus: string;
    imageKey: string;
    imageSrc: string;
    type: "2d" | "3d";
    handleSelect: (value:  IAvatarGender) => void;
    handleImageLoad: (value: string) => void;
    handleImageError: (value: string) => void;
}

export const AvatarOption: React.FC<Props> = ({
  el,
  isSelected,
  imageStatus,
  imageSrc,
  type,
  handleSelect,
  handleImageLoad,
  handleImageError,
}) => {
  return (
    <label
      key={el.value}
      className={`${styles.avatarsOption} ${isSelected ? styles.selected : ""}`}
    >
      <input
        type="radio"
        name="avatar"
        id={el.value}
        value={el.value}
        checked={isSelected}
        onChange={() => handleSelect(el)}
        className={styles.hiddenRadio}
      />
      <img
        src={imageSrc}
        alt={imageStatus === "error" ? "error avatar view" : el.description}
        onLoad={() => handleImageLoad(el.value)}
        onError={() => handleImageError(el.value)}
      />
      {isSelected && imageStatus === "loaded" && (
        <div className={styles.checkmark}>
          <img src={checkIcon} alt="check icon" />
        </div>
      )}
    </label>
  );
};